export default __webpack_public_path__ + "static/media/main-logo.9749dc11.svg";